/* eslint-disable @typescript-eslint/no-unused-vars */
import moment from 'moment';
import { safeParseJson } from '../../lib';
import { withAPIAccount } from '../../lib/http/api';
import { APIError, parsedResponse } from '../../lib/http/http';
import { AccountType } from '../../model';
import {
  CommonStatusStep,
  IAPICommonCosConfigRes,
  IAPICompanyFullInfo,
  IAPICompanyRes,
  ICertInfo,
  ICreateCompanyBody,
  ICreateInternalCompanyBody,
  ICrosProductListItem,
  StudioCertifiedType,
} from '../../model/api-modules';
import { API_PREFIX, COMPANY_PREFIX } from '../config';
import { getReformCompanyInfo } from './lib';

// 获取工作室企业信息
export const getCompanyInfo = (studioID: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${COMPANY_PREFIX}/info/${studioID}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IAPICompanyRes | null>(response, 'data');
      return getReformCompanyInfo(res);
    } catch (error) {
      console.log(error);
      return;
    }
  });

// 提交企业认证
export const submitCompanyInfo = (info: ICreateCompanyBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${COMPANY_PREFIX}/certified`;
      const response = await api.commonRequest('POST', url, info);
      await parsedResponse<IAPICompanyRes | null>(response, 'data');
      return true;
    } catch (error: any) {
      console.log(error);
      return false;
    }
  });

// 更新企业认证
export const updateCompanyInfo = (id: number, info: ICreateCompanyBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${COMPANY_PREFIX}/certified`;
      const response = await api.commonRequest('PUT', url, info);
      await parsedResponse<IAPICompanyRes | null>(response, 'data');
      return true;
    } catch (error: any) {
      console.log(error);
      return false;
    }
  });

export const getKpiCodeList = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/cros-app/product/list`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<ICrosProductListItem[]>(
        response,
        'data'
      );
      return res;
    } catch (error: any) {
      console.log(error);
      return [];
    }
  });

// 创建内部企业认证
export const createInternalCompanyInfo = (data: ICreateInternalCompanyBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${COMPANY_PREFIX}/certified/internal`;
      const response = await api.commonRequest('POST', url, data);
      await parsedResponse<any>(response, 'data');
      return true;
    } catch (error: any) {
      console.log(error);
      return false;
    }
  });

// 更新内部企业认证
export const updateInternalCompanyInfo = (data: ICreateInternalCompanyBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${COMPANY_PREFIX}/certified/internal`;
      const response = await api.commonRequest('PUT', url, data);
      await parsedResponse<IAPICompanyRes | null>(response, 'data');
      return true;
    } catch (error: any) {
      console.log(error);
      return false;
    }
  });

export const getCompanyCosConfig = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/cos/sts/company/config`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IAPICommonCosConfigRes>(
        response,
        'data'
      );
      return res;
    } catch (error) {
      console.log(error);
      return;
    }
  });
